import httpClient from "../../_helpers/axiosHelper";
import {PdvModel} from "../../Models/PdvModel";
import {OrderModel} from "../../Models/OrderModel";
import axios from "axios";
import {authMock} from "../../mocks/authMock";
import {eventMock} from "../../mocks/eventMock";
import {productMock} from "../../mocks/products/productMock";
import {pdvMock} from "../../mocks/pdvs/pdvMock";
import {orderResponseMock} from "../../mocks/orderResponseMock";
import {EventModel} from "../../Models/EventModel";
import {StadiumModel} from "../../Models/StadiumModel";
import {ProductModel} from "../../Models/ProductModel";
import {OrderResponseModel} from "../../Models/OrderResponseModel";
import useGetTokenOrRefresh from "./useGetTokenOrRefresh";

interface HttpClientModel {
    auth: (body: any) => Promise<{token: string, stadium: StadiumModel}>,
    getEvent: () => Promise<EventModel>,
    getProducts: (idPdv: string) => Promise<ProductModel[]>,
    getPdvs: (doorId: string) => Promise<PdvModel[]>,
    postOrder: (order: OrderModel) => Promise<OrderResponseModel>,
    getOrderDetail: (reference: string) => Promise<OrderModel[]>
}

const useHttpClient = (): HttpClientModel => {

    const isMocked = process.env.REACT_APP_MOCK === 'true'
    const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms))

    const auth = async(body: any): Promise<{token: string, stadium: StadiumModel}> => {
        if(isMocked) {
            await sleep(500)
            return authMock
        }
        const res = await axios.post(`${process.env.REACT_APP_TOPIVO_URL}/authentication/bart`, body).catch(err => {
            return Promise.reject(err)
        })
        return res.data
    }

    const getToken = useGetTokenOrRefresh(auth)

    const getEvent = async(): Promise<EventModel> => {
        if(isMocked) {
            await sleep(500)
            // return Promise.reject({"code":400,"title":"Error","message":"Aucun \u00e9v\u00e8nement en cours"})
            return eventMock
        }
        const res = await httpClient(await getToken()).get('/api/bart/event').catch(err => {
            return Promise.reject(err)
        })
        return res.data
    }

    const getProducts = async(idPdv: string): Promise<ProductModel[]> => {
        if(isMocked) {
            await sleep(1000)
            return productMock.get(idPdv) || []
        }
        const res = await httpClient(await getToken()).get(`/api/bart/pdvs/${idPdv}/products`).catch(err => {
            return Promise.reject(err)
        })
        return res.data
    }

    const getPdvs = async (doorId: string): Promise<PdvModel[]> => {
        if(isMocked) {
            await sleep(1000)
            return pdvMock.get(doorId) || []
        }
        let nextPage: number | null = 1
        const result: PdvModel[] = []
        while (nextPage) {
            const res: any = await httpClient(await getToken()).get(`/api/bart/doors/${doorId}/pdvs?page=${nextPage}`)
                .catch(err => Promise.reject(err))
            result.push(...res.data.data)
            nextPage = res.data.meta.next_page
        }
        return result
    }

    const postOrder = async(order: OrderModel): Promise<OrderResponseModel> => {
        if(isMocked) {
          console.log(order)
            await sleep(1000)
            return orderResponseMock(order)
        }
        const res = await httpClient(await getToken()).post('/api/bart/orders', order).catch(err => {
            return Promise.reject(err)
        })
        return res.data
    }

    const getOrderDetail = async(reference: string): Promise<OrderModel[]> => {
        if(isMocked) {
            await sleep(1000)
            if(reference === "B111") {
                const order: OrderModel = {createdAt: new Date()}
                return [order]
            }
            return Promise.reject()
        }
        const res = await httpClient(await getToken()).get(`/api/bart/orders/${reference}`).catch(err => {
            return Promise.reject(err)
        })
        return res.data
    }

    return {
        auth,
        getEvent,
        getProducts,
        getPdvs,
        postOrder,
        getOrderDetail
    }

}

export default useHttpClient
